import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config"
import {log} from "@/composables/useLog"
import axios from "axios"

const error = ref(null)

const getHeaders = (token) => ({
    "Authorization": `Bearer ${token}`,
    "Content-Type": "application/json",
    "Accept": "application/json"
})

// ================== DUNNING RULES API ==================

export const getDunningRules = async (token, filters = {}) => {
    log("getDunningRules called")
    if (!token) return {error: true, message: "No token provided", rules: []}

    try {
        const result = await axios.get(BASE_URL + '/dunning/get_rules_api', {headers: getHeaders(token), params: filters})
        return result.data
    } catch (err) {
        log("Error in getDunningRules: " + err.message)
        error.value = err.message
        return {error: true, message: "Error loading dunning rules", rules: []}
    }
}

export const createDunningRule = async (token, ruleData) => {
    log("createDunningRule called")
    if (!token) return {error: true, message: "No token provided"}

    try {
        const result = await axios.post(BASE_URL + '/dunning/create_rule_api', ruleData, {headers: getHeaders(token)})
        return result.data
    } catch (err) {
        log("Error in createDunningRule: " + err.message)
        error.value = err.message
        return {error: true, message: "Error creating dunning rule"}
    }
}

export const updateDunningRule = async (token, ruleData) => {
    log("updateDunningRule called")
    if (!token) return {error: true, message: "No token provided"}

    try {
        const result = await axios.put(BASE_URL + '/dunning/update_rule_api', ruleData, {headers: getHeaders(token)})
        return result.data
    } catch (err) {
        log("Error in updateDunningRule: " + err.message)
        error.value = err.message
        return {error: true, message: "Error updating dunning rule"}
    }
}

export const deleteDunningRule = async (token, ruleId) => {
    log("deleteDunningRule called")
    if (!token) return {error: true, message: "No token provided"}

    try {
        const result = await axios.delete(BASE_URL + '/dunning/delete_rule_api', {headers: getHeaders(token), params: {id: ruleId}})
        return result.data
    } catch (err) {
        log("Error in deleteDunningRule: " + err.message)
        error.value = err.message
        return {error: true, message: "Error deleting dunning rule"}
    }
}

export const toggleDunningRule = async (token, ruleId) => {
    log("toggleDunningRule called")
    if (!token) return {error: true, message: "No token provided"}

    try {
        const result = await axios.put(BASE_URL + '/dunning/toggle_rule_api', {id: ruleId}, {headers: getHeaders(token)})
        return result.data
    } catch (err) {
        log("Error in toggleDunningRule: " + err.message)
        error.value = err.message
        return {error: true, message: "Error toggling dunning rule"}
    }
}

export const getDunningLogs = async (token, filters = {}) => {
    log("getDunningLogs called")
    if (!token) return {error: true, message: "No token provided", logs: []}

    try {
        const result = await axios.get(BASE_URL + '/dunning/get_logs_api', {headers: getHeaders(token), params: filters})
        return result.data
    } catch (err) {
        log("Error in getDunningLogs: " + err.message)
        error.value = err.message
        return {error: true, message: "Error loading dunning logs", logs: []}
    }
}

export const dunningDryRun = async (token) => {
    log("dunningDryRun called")
    if (!token) return {error: true, message: "No token provided", results: []}

    try {
        const result = await axios.post(BASE_URL + '/dunning/dry_run_api', {}, {headers: getHeaders(token)})
        return result.data
    } catch (err) {
        log("Error in dunningDryRun: " + err.message)
        error.value = err.message
        return {error: true, message: "Error running dry run", results: []}
    }
}

export const getDunningActionTypes = async (token) => {
    log("getDunningActionTypes called")
    if (!token) return {error: true, message: "No token provided", action_types: []}

    try {
        const result = await axios.get(BASE_URL + '/dunning/get_action_types_api', {headers: getHeaders(token)})
        return result.data
    } catch (err) {
        log("Error in getDunningActionTypes: " + err.message)
        error.value = err.message
        return {error: true, message: "Error loading action types", action_types: []}
    }
}

export const getDunningAccessibleServices = async (token, clientId) => {
    log("getDunningAccessibleServices called for client " + clientId)
    if (!token) return {error: true, message: "No token provided", services: [], service_types: []}

    try {
        const params = clientId ? {client_id: clientId} : {}
        const result = await axios.get(BASE_URL + '/dunning/get_accessible_services_api', {headers: getHeaders(token), params})
        return result.data
    } catch (err) {
        log("Error in getDunningAccessibleServices: " + err.message)
        error.value = err.message
        return {error: true, message: "Error loading accessible services", services: [], service_types: []}
    }
}
